import { useEffect, useState } from 'react';

const useFooterAwareOffset = ({
  desktopBottom = 24,
  mobileBottom = 88,
  mobileBreakpoint = 860,
  extraLift = 12
} = {}) => {
  const getBaseOffset = () => {
    if (typeof window === 'undefined') {
      return desktopBottom;
    }
    return window.innerWidth <= mobileBreakpoint ? mobileBottom : desktopBottom;
  };

  const [bottomOffset, setBottomOffset] = useState(getBaseOffset);

  useEffect(() => {
    let rafId = 0;

    const calculateBottom = () => {
      const footer = document.querySelector('.footer');
      const baseOffset =
        window.innerWidth <= mobileBreakpoint ? mobileBottom : desktopBottom;

      if (!footer) {
        setBottomOffset(baseOffset);
        return;
      }

      const footerRect = footer.getBoundingClientRect();
      const visibleFooter = Math.max(0, window.innerHeight - footerRect.top);
      const lift = visibleFooter > 0 ? visibleFooter + extraLift : 0;

      setBottomOffset(baseOffset + lift);
    };

    const requestMeasure = () => {
      cancelAnimationFrame(rafId);
      rafId = window.requestAnimationFrame(calculateBottom);
    };

    requestMeasure();

    window.addEventListener('scroll', requestMeasure, { passive: true });
    window.addEventListener('resize', requestMeasure);

    return () => {
      cancelAnimationFrame(rafId);
      window.removeEventListener('scroll', requestMeasure);
      window.removeEventListener('resize', requestMeasure);
    };
  }, [desktopBottom, mobileBottom, mobileBreakpoint, extraLift]);

  return bottomOffset;
};

export default useFooterAwareOffset;
